import { Link } from 'react-router';

import { setPageTitle } from '@/lib/utils';
import { ROUTES } from '@/routes';

export function NotFoundPage() {
  setPageTitle('404 - Not Found');
  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center space-y-4">
        <h1 className="text-8xl font-bold text-primary-500">404</h1>
        <p className="text-gray-500 dark:text-gray-400">Page not found.</p>
        <Link
          to={ROUTES.dashboard}
          className="inline-block text-primary-500 hover:text-primary-600 hover:underline text-sm"
        >
          Back to dashboard
        </Link>
      </div>
    </main>
  );
}
